.category-header {
  margin-bottom: 32px;
  width: 100%;
}

@media screen and (min-width: 980px) {
  .category-header {
    max-width: 1200px;
    margin: 0 auto 40px;
  }
}